// (() => {

//   // =====================================================
//   // RUGMATTERS
//   // SHOPIFY ↔ ZEPTO VARIANT SYNC
//   // =====================================================

//   const DEBUG = false;

//   const log = (...args) => {
//     if (DEBUG) {
//       console.log(
//         '[RUG VARIANT SYNC]',
//         ...args
//       );
//     }
//   };


//   // =====================================================
//   // ZEPTO PROPERTY NAMES
//   // =====================================================

//   const SHAPE_PROPERTY =
//     'properties[Rug Shape]';

//   const SIZE_PROPERTY = {
//     area:
//       'properties[Area Rug Size]',

//     runner:
//       'properties[Runner Rug Size]',

//     square:
//       'properties[Square Rug Size]',

//     round:
//       'properties[Round Rug Size]'
//   };


//   // =====================================================
//   // DEFAULT SIZE WHEN CUSTOMER CHANGES SHAPE
//   // =====================================================

//   const DEFAULT_SIZE = {
//     area: `5' x 7'`,
//     runner: `2.5' x 7'`,
//     square: `5' x 5'`,
//     round: `5' Round`
//   };


//   // =====================================================
//   // HELPERS
//   // =====================================================

//   function normalize(value) {

//     return String(value || '')
//       .toLowerCase()
//       .replace(/[’']/g, '')
//       .replace(/["]/g, '')
//       .replace(/[×*]/g, 'x')
//       .replace(/\s*x\s*/g, 'x')
//       .replace(/\s+/g, ' ')
//       .trim();

//   }


//   function escapeCSS(value) {

//     if (
//       window.CSS &&
//       typeof CSS.escape === 'function'
//     ) {
//       return CSS.escape(value);
//     }

//     return String(value)
//       .replace(/"/g, '\\"');

//   }


//   function visible(element) {

//     if (!element) return false;

//     const style =
//       getComputedStyle(element);

//     return (
//       style.display !== 'none' &&
//       style.visibility !== 'hidden' &&
//       !element.closest('[hidden]')
//     );

//   }


//   function sleep(ms) {

//     return new Promise(resolve => {
//       setTimeout(resolve, ms);
//     });

//   }


//   // Prevent our own clicks from triggering
//   // the opposite sync direction again.
//   let programmaticChange = false;

//     // const initializedShapes = new Set();
//     const rememberedSizes = new Map();
//     function rememberSize(shape, size) {
//   shape = normalize(shape);

//   if (!shape || !size) return;

//   rememberedSizes.set(shape, size);

//   log(
//     'Remembered customer size:',
//     shape,
//     size
//   );
// }


// function getSizeForShape(shape) {
//   shape = normalize(shape);

//   return (
//     rememberedSizes.get(shape) ||
//     DEFAULT_SIZE[shape] ||
//     null
//   );
// }
//   // =====================================================
//   // DETERMINE SHAPE FROM SIZE
//   // =====================================================

//   function getShapeFromSize(size) {

//     const s =
//       normalize(size);

//     if (!s) return null;


//     // ROUND
//     if (
//       s.includes('round')
//     ) {
//       return 'round';
//     }


//     // RUNNER
//     if (
//       s.startsWith('2.5x')
//     ) {
//       return 'runner';
//     }


//     // SQUARE
//     const match =
//       s.match(
//         /^([\d.]+)x([\d.]+)$/
//       );

//     if (match) {

//       const width =
//         parseFloat(match[1]);

//       const length =
//         parseFloat(match[2]);

//       if (
//         !isNaN(width) &&
//         !isNaN(length) &&
//         width === length
//       ) {
//         return 'square';
//       }

//     }


//     // Everything else = AREA
//     return 'area';

//   }


//   // =====================================================
//   // GET SHOPIFY PRODUCT JSON
//   // =====================================================

//   function getShopifyProduct() {

//     if (
//       window.meta &&
//       window.meta.product &&
//       Array.isArray(
//         window.meta.product.variants
//       )
//     ) {

//       return window.meta.product;

//     }


//     const possibleJSON = [

//       document.querySelector(
//         'script[type="application/json"][data-product]'
//       ),

//       document.querySelector(
//         'script[type="application/json"][data-product-json]'
//       ),

//       document.querySelector(
//         'product-form script[type="application/json"]'
//       ),

//       document.querySelector(
//         'script[id^="ProductJson-"]'
//       )

//     ].filter(Boolean);


//     for (
//       const element of possibleJSON
//     ) {

//       try {

//         const parsed =
//           JSON.parse(
//             element.textContent
//           );

//         if (
//           parsed &&
//           Array.isArray(
//             parsed.variants
//           )
//         ) {
//           return parsed;
//         }

//       } catch (_) {}

//     }


//     log(
//       'Could not find Shopify product JSON'
//     );

//     return null;

//   }


//   // =====================================================
//   // CURRENT SHOPIFY VARIANT
//   // =====================================================

//   function getCurrentVariantId() {

//     // First respect variant in URL
//     const url =
//       new URL(
//         window.location.href
//       );

//     const urlVariant =
//       url.searchParams.get(
//         'variant'
//       );

//     if (urlVariant) {

//       return Number(
//         urlVariant
//       );

//     }


//     // Otherwise Shopify hidden variant input
//     const input =

//       document.querySelector(
//         'form[action*="/cart/add"] input[name="id"]'
//       ) ||

//       document.querySelector(
//         'form[action*="/cart/add"] select[name="id"]'
//       );


//     if (
//       input &&
//       input.value
//     ) {

//       return Number(
//         input.value
//       );

//     }


//     return null;

//   }


//   // =====================================================
//   // GET SIZE FROM SHOPIFY VARIANT
//   // =====================================================

//   function getVariantSize(variant) {

//     if (!variant) return '';


//     const options =
//       variant.options ||
//       variant.option_values ||
//       [];


//     // Look for option that looks like a rug size
//     const sizeOption =
//       options.find(value => {

//         const n =
//           normalize(value);

//         return (
//           n.includes('x') ||
//           n.includes('round')
//         );

//       });


//     if (sizeOption) {

//       return sizeOption;

//     }


//     // Fallback to variant title
//     const title =

//       variant.public_title ||
//       variant.title ||
//       variant.name ||
//       '';


//     if (!title) return '';


//     const parts =
//       title.split(
//         /\s[-–—]\s/
//       );


//     return (
//       parts[
//         parts.length - 1
//       ] || ''
//     ).trim();

//   }


//   // =====================================================
//   // FIND ZEPTO VISUAL BUTTON
//   // =====================================================

//   function findZeptoButton(text) {

//     const target =
//       normalize(text);


//     const buttons =
//       Array.from(
//         document.querySelectorAll(
//           '.pplr-drop-item, .pplr-swatch-element'
//         )
//       );


//     // Prefer visible match
//     const visibleMatch =
//       buttons.find(button => {

//         if (!visible(button)) {
//           return false;
//         }

//         const value =
//           button.getAttribute(
//             'data-value'
//           ) ||
//           button.textContent;

//         return (
//           normalize(value) ===
//           target
//         );

//       });


//     if (visibleMatch) {

//       return visibleMatch;

//     }


//     // Fallback any exact match
//     return (
//       buttons.find(button => {

//         const value =
//           button.getAttribute(
//             'data-value'
//           ) ||
//           button.textContent;

//         return (
//           normalize(value) ===
//           target
//         );

//       }) ||
//       null
//     );

//   }


//   // =====================================================
//   // SET ZEPTO SHAPE
//   // =====================================================

//   function setZeptoShape(shape) {

//     shape =
//       normalize(shape);

//     if (!shape) return false;


//     const expected =
//       shape.charAt(0)
//         .toUpperCase() +
//       shape.slice(1);


//     log(
//       'Selecting Zepto shape:',
//       expected
//     );


//     // Try actual Zepto property input first
//     const elements =
//       Array.from(
//         document.querySelectorAll(
//           `[name="${escapeCSS(
//             SHAPE_PROPERTY
//           )}"]`
//         )
//       );


//     const matchingInput =
//       elements.find(el => {

//         return (
//           normalize(el.value) ===
//           normalize(expected)
//         );

//       });


//     if (matchingInput) {

//       if (
//         matchingInput.tagName ===
//         'SELECT'
//       ) {

//         if (
//           normalize(
//             matchingInput.value
//           ) !== normalize(expected)
//         ) {

//           matchingInput.value =
//             expected;

//           matchingInput.dispatchEvent(
//             new Event(
//               'input',
//               {
//                 bubbles: true
//               }
//             )
//           );

//           matchingInput.dispatchEvent(
//             new Event(
//               'change',
//               {
//                 bubbles: true
//               }
//             )
//           );

//         }

//         return true;

//       }


//       if (
//         !matchingInput.checked
//       ) {

//         matchingInput.click();

//       }

//       return true;

//     }


//     // Fallback visual Zepto button
//     const button =
//       findZeptoButton(
//         expected
//       );


//     if (button) {

//       button.click();

//       return true;

//     }


//     log(
//       'Could not find Zepto shape:',
//       expected
//     );

//     return false;

//   }


//   // =====================================================
//   // SET ZEPTO SIZE
//   // =====================================================

//   function setZeptoSize(
//     shape,
//     size
//   ) {

//     shape =
//       normalize(shape);

//     if (
//       !shape ||
//       !size
//     ) {
//       return false;
//     }


//     const property =
//       SIZE_PROPERTY[
//         shape
//       ];


//     if (!property) {

//       log(
//         'No Zepto size property for:',
//         shape
//       );

//       return false;

//     }


//     log(
//       'Selecting Zepto size:',
//       shape,
//       size
//     );


//     // RADIO
//     const radios =
//       Array.from(
//         document.querySelectorAll(
//           `input[type="radio"][name="${escapeCSS(
//             property
//           )}"]`
//         )
//       );


//     const radio =
//       radios.find(r => {

//         return (
//           normalize(r.value) ===
//           normalize(size)
//         );

//       });


//     if (radio) {

//       if (!radio.checked) {

//         radio.click();

//       }

//       return true;

//     }


//     // SELECT
//     const selects =
//       Array.from(
//         document.querySelectorAll(
//           `select[name="${escapeCSS(
//             property
//           )}"]`
//         )
//       );


//     for (
//       const select of selects
//     ) {

//       const option =
//         Array.from(
//           select.options
//         ).find(option => {

//           return (
//             normalize(
//               option.value
//             ) ===
//               normalize(size) ||

//             normalize(
//               option.textContent
//             ) ===
//               normalize(size)
//           );

//         });


//       if (option) {

//         select.value =
//           option.value;

//         select.dispatchEvent(
//           new Event(
//             'input',
//             {
//               bubbles: true
//             }
//           )
//         );

//         select.dispatchEvent(
//           new Event(
//             'change',
//             {
//               bubbles: true
//             }
//           )
//         );

//         return true;

//       }

//     }


//     // VISUAL BUTTON FALLBACK
//     const button =
//       findZeptoButton(
//         size
//       );


//     if (button) {

//       button.click();

//       return true;

//     }


//     log(
//       'Could not find Zepto size:',
//       size
//     );

//     return false;

//   }


//   // =====================================================
//   // SHOPIFY → ZEPTO
//   // =====================================================

//   async function selectZeptoFromShopifyVariant() {

//     const product =
//       getShopifyProduct();


//     if (!product) {

//       log(
//         'Shopify product JSON not ready'
//       );

//       return false;

//     }


//     const variantId =
//       getCurrentVariantId();


//     if (!variantId) {

//       log(
//         'No current Shopify variant ID'
//       );

//       return false;

//     }


//     const variant =
//       product.variants.find(
//         variant => {

//           return (
//             Number(variant.id) ===
//             Number(variantId)
//           );

//         }
//       );


//     if (!variant) {

//       log(
//         'Shopify variant not found:',
//         variantId
//       );

//       return false;

//     }


//     const size =
//       getVariantSize(
//         variant
//       );


//     if (!size) {

//       log(
//         'Could not determine Shopify variant size'
//       );

//       return false;

//     }


//     const shape =
//       getShapeFromSize(
//         size
//       );


//     log(
//       'SHOPIFY → ZEPTO',
//       'Variant:',
//       variantId,
//       'Shape:',
//       shape,
//       'Size:',
//       size
//     );


//     programmaticChange =
//       true;


//     setZeptoShape(
//       shape
//     );


//     // Give Zepto time to show correct size field
//     await sleep(250);


//     setZeptoSize(
//       shape,
//       size
//     );


//     await sleep(250);


//     programmaticChange =
//       false;


//     return true;

//   }


//   // =====================================================
//   // FIND REAL SHOPIFY SIZE INPUT
//   // =====================================================

//   function findShopifySizeRadio(size) {

//     const target =
//       normalize(size);


//     const radios =
//       Array.from(
//         document.querySelectorAll(
//           'input[type="radio"]'
//         )
//       );


//     return (
//       radios.find(input => {

//         // Ignore Zepto product properties
//         if (
//           String(
//             input.name || ''
//           ).startsWith(
//             'properties['
//           )
//         ) {
//           return false;
//         }


//         const value =
//           normalize(
//             input.value
//           );


//         if (
//           value === target
//         ) {
//           return true;
//         }


//         // Check associated label
//         if (input.id) {

//           const label =
//             document.querySelector(
//               `label[for="${escapeCSS(
//                 input.id
//               )}"]`
//             );


//           if (
//             label &&
//             normalize(
//               label.textContent
//             ) === target
//           ) {
//             return true;
//           }

//         }


//         return false;

//       }) ||
//       null
//     );

//   }


//   // =====================================================
//   // FIND REAL SHOPIFY SIZE SELECT
//   // =====================================================

//   function findShopifySizeSelect(
//     size
//   ) {

//     const target =
//       normalize(size);


//     const selects =
//       Array.from(
//         document.querySelectorAll(
//           'select'
//         )
//       );


//     for (
//       const select of selects
//     ) {

//       if (
//         String(
//           select.name || ''
//         ).startsWith(
//           'properties['
//         )
//       ) {
//         continue;
//       }


//       const option =
//         Array.from(
//           select.options
//         ).find(option => {

//           return (
//             normalize(
//               option.value
//             ) === target ||

//             normalize(
//               option.textContent
//             ) === target
//           );

//         });


//       if (option) {

//         return {
//           select,
//           option
//         };

//       }

//     }


//     return null;

//   }


//   // =====================================================
//   // ZEPTO → SHOPIFY
//   // =====================================================
// function selectShopifySize(size) {

//   if (!size) return false;

//   log(
//     'ZEPTO → SHOPIFY SIZE:',
//     size
//   );

//   const radio = findShopifySizeRadio(size);

//   if (radio) {

//     log(
//       'Found Shopify size radio:',
//       radio.value
//     );

//     programmaticChange = true;

//     /*
//       Force the real Shopify option into selected state.
//     */
//     radio.checked = true;

//     /*
//       Trigger ALL common events Shopify themes may listen for.
//     */
//     radio.dispatchEvent(
//       new Event('input', {
//         bubbles: true
//       })
//     );

//     radio.dispatchEvent(
//       new Event('change', {
//         bubbles: true
//       })
//     );

//     /*
//       Also click the associated label.
//       Some themes attach variant logic to the label/button.
//     */
//     if (radio.id) {

//       const label = document.querySelector(
//         `label[for="${escapeCSS(radio.id)}"]`
//       );

//       if (label) {
//         label.click();
//       } else {
//         radio.click();
//       }

//     } else {
//       radio.click();
//     }


//     /*
//       Fire change one more time AFTER click.
//       This helps themes that rebuild variant DOM.
//     */
//     setTimeout(() => {

//       radio.dispatchEvent(
//         new Event('change', {
//           bubbles: true
//         })
//       );

//     }, 50);


//     setTimeout(() => {

//       programmaticChange = false;

//     }, 400);


//     return true;
//   }



//   /*
//     SELECT FALLBACK
//   */
//   const foundSelect =
//     findShopifySizeSelect(size);

//   if (foundSelect) {

//     log(
//       'Found Shopify size select:',
//       foundSelect.option.value
//     );

//     programmaticChange = true;

//     foundSelect.select.value =
//       foundSelect.option.value;


//     foundSelect.select.dispatchEvent(
//       new Event('input', {
//         bubbles: true
//       })
//     );

//     foundSelect.select.dispatchEvent(
//       new Event('change', {
//         bubbles: true
//       })
//     );


//     setTimeout(() => {

//       programmaticChange = false;

//     }, 400);


//     return true;
//   }


//   log(
//     'SHOPIFY SIZE NOT FOUND:',
//     size
//   );

//   return false;
// }
//   // function selectShopifySize(
//   //   size
//   // ) {

//   //   if (!size) return false;


//   //   log(
//   //     'ZEPTO → SHOPIFY SIZE:',
//   //     size
//   //   );


//   //   // ==========================================
//   //   // 1. Shopify radio/button
//   //   // ==========================================

//   //   const radio =
//   //     findShopifySizeRadio(
//   //       size
//   //     );


//   //   if (radio) {

//   //     log(
//   //       'Found Shopify size radio:',
//   //       radio.value
//   //     );


//   //     programmaticChange =
//   //       true;


//   //     // IMPORTANT:
//   //     // Real click lets the Shopify theme
//   //     // update variant ID, price, URL, media, ATC.
//   //     if (!radio.checked) {

//   //       radio.click();

//   //     } else {

//   //       radio.dispatchEvent(
//   //         new Event(
//   //           'change',
//   //           {
//   //             bubbles: true
//   //           }
//   //         )
//   //       );

//   //     }


//   //     setTimeout(() => {

//   //       programmaticChange =
//   //         false;

//   //     }, 300);


//   //     return true;

//   //   }


//   //   // ==========================================
//   //   // 2. Shopify select fallback
//   //   // ==========================================

//   //   const foundSelect =
//   //     findShopifySizeSelect(
//   //       size
//   //     );


//   //   if (foundSelect) {

//   //     log(
//   //       'Found Shopify size select:',
//   //       foundSelect.option.value
//   //     );


//   //     programmaticChange =
//   //       true;


//   //     foundSelect.select.value =
//   //       foundSelect.option.value;


//   //     foundSelect.select.dispatchEvent(
//   //       new Event(
//   //         'input',
//   //         {
//   //           bubbles: true
//   //         }
//   //       )
//   //     );


//   //     foundSelect.select.dispatchEvent(
//   //       new Event(
//   //         'change',
//   //         {
//   //           bubbles: true
//   //         }
//   //       )
//   //     );


//   //     setTimeout(() => {

//   //       programmaticChange =
//   //         false;

//   //     }, 300);


//   //     return true;

//   //   }


//   //   log(
//   //     'SHOPIFY SIZE NOT FOUND:',
//   //     size
//   //   );


//   //   return false;

//   // }


// // =====================================================
// // MANUAL SHAPE → DEFAULT SIZE
// // ONLY FIRST TIME EACH SHAPE IS OPENED
// // =====================================================

// // async function selectDefaultForShape(shape) {

// //   shape = normalize(shape);

// //   if (!shape) return;


// //   // Already initialized before?
// //   // Do NOT overwrite customer's selected size.
// //   if (initializedShapes.has(shape)) {

// //     log(
// //       'Shape already initialized → keeping current size:',
// //       shape
// //     );

// //     return;
// //   }


// //   const target =
// //     DEFAULT_SIZE[shape];

// //   if (!target) return;


// //   // Mark immediately so duplicate Zepto events
// //   // cannot run this again.
// //   initializedShapes.add(shape);


// //   log(
// //     'FIRST OPEN:',
// //     shape,
// //     '→ DEFAULT SIZE:',
// //     target
// //   );


// //   programmaticChange = true;


// //   // Allow Zepto to reveal this shape's size options
// //   await sleep(200);


// //   setZeptoSize(
// //     shape,
// //     target
// //   );


// //   await sleep(100);


// //   programmaticChange = false;


// //   // Match Shopify variant + price
// //   selectShopifySize(
// //     target
// //   );
// // }

// // =====================================================
// // SHAPE CHANGE → RESTORE SIZE OR USE SHAPE DEFAULT
// // =====================================================

// async function selectSizeForShape(shape) {

//   shape = normalize(shape);

//   if (!shape) return;


//   const remembered =
//     rememberedSizes.get(shape);

//   const target =
//     remembered ||
//     DEFAULT_SIZE[shape];


//   if (!target) return;


//   log(
//     remembered
//       ? 'RESTORING CUSTOMER SIZE:'
//       : 'USING SHAPE DEFAULT:',
//     shape,
//     target
//   );


//   programmaticChange = true;


//   /*
//     Give Zepto time to display the correct
//     size field for the newly selected shape.
//   */
//   await sleep(200);


//   setZeptoSize(
//     shape,
//     target
//   );


//   await sleep(100);


//   programmaticChange = false;


//   /*
//     Match the real Shopify variant,
//     price, media and Add to Cart.
//   */
//   selectShopifySize(
//     target
//   );
// }
//   // =====================================================
//   // LISTEN FOR MANUAL ZEPTO SHAPE CLICK
//   // =====================================================

//   document.addEventListener(
//     'click',
//     event => {

//       if (
//         programmaticChange
//       ) {
//         return;
//       }


//       const button =
//         event.target.closest(
//           '.pplr-drop-item, .pplr-swatch-element'
//         );


//       if (!button) return;


//       const value =
//         normalize(

//           button.getAttribute(
//             'data-value'
//           ) ||

//           button.textContent

//         );


//       if (
//         ![
//           'area',
//           'runner',
//           'square',
//           'round'
//         ].includes(value)
//       ) {
//         return;
//       }


//       // Wait for Zepto's own click first
//       setTimeout(() => {

//         if (
//           !programmaticChange
//         ) {

//           selectSizeForShape(
//             value
//           );

//         }

//       }, 50);

//     },
//     true
//   );


//   // =====================================================
//   // LISTEN FOR ZEPTO SHAPE INPUT CHANGE
//   // =====================================================

//   document.addEventListener(
//     'change',
//     event => {

//       if (
//         programmaticChange
//       ) {
//         return;
//       }


//       const el =
//         event.target;


//       if (
//         !el ||
//         el.name !==
//           SHAPE_PROPERTY
//       ) {
//         return;
//       }


//       const shape =
//         normalize(
//           el.value
//         );


//       if (
//         ![
//           'area',
//           'runner',
//           'square',
//           'round'
//         ].includes(shape)
//       ) {
//         return;
//       }


//       selectSizeForShape(
//         shape
//       );

//     },
//     true
//   );


//   // =====================================================
//   // LISTEN FOR ACTUAL ZEPTO SIZE INPUT CHANGE
//   // =====================================================

//   document.addEventListener(
//     'change',
//     event => {

//       if (
//         programmaticChange
//       ) {
//         return;
//       }


//       const el =
//         event.target;


//       if (
//         !el ||
//         !el.name
//       ) {
//         return;
//       }

//         const SIZE_PROPERTIES = Object.values(SIZE_PROPERTY);
//         if (!SIZE_PROPERTIES.includes(el.name)) return;


//       const size =
//         el.value;


//       if (!size) return;
//       // Remember that this shape now has a chosen size.
//             // Do not force its default again later.
//             // const shapeForThisSize =
//             // getShapeFromSize(size);

//             // if (shapeForThisSize) {

//             // initializedShapes.add(
//             //     shapeForThisSize
//             // );

//             // log(
//             //     'Remembering selected size for:',
//             //     shapeForThisSize,
//             //     size
//             // );
//             // }
//             const shapeForThisSize =
//           getShapeFromSize(size);

//         if (shapeForThisSize) {

//           rememberSize(
//             shapeForThisSize,
//             size
//           );

//         }


//       log(
//         'Zepto size input changed:',
//         size
//       );


//       setTimeout(() => {

//         if (
//           !programmaticChange
//         ) {

//           selectShopifySize(
//             size
//           );

//         }

//       }, 50);

//     },
//     true
//   );


//   // =====================================================
//   // ZEPTO VISUAL SIZE CLICK FALLBACK
//   // =====================================================

//   document.addEventListener(
//     'click',
//     event => {

//       if (
//         programmaticChange
//       ) {
//         return;
//       }


//       const button =
//         event.target.closest(
//           '.pplr-drop-item, .pplr-swatch-element'
//         );


//       if (!button) return;


//       const rawValue =

//         button.getAttribute(
//           'data-value'
//         ) ||

//         button.textContent ||

//         '';


//       const value =
//         rawValue.trim();
//                 const shapeForThisSize =
//           getShapeFromSize(value);

//         if (shapeForThisSize) {

//           rememberSize(
//             shapeForThisSize,
//             value
//           );

//         }


//       const normalized =
//         normalize(
//           value
//         );


//       // Ignore shape buttons
//       if (
//         [
//           'area',
//           'runner',
//           'square',
//           'round'
//         ].includes(
//           normalized
//         )
//       ) {
//         return;
//       }


//       // Must resemble a rug size
//       if (
//         !normalized.includes('x') &&
//         !normalized.includes('round')
//       ) {
//         return;
//       }


//       log(
//         'Zepto visual size clicked:',
//         value
//       );


//       // Let Zepto finish first
//       setTimeout(() => {

//         if (
//           !programmaticChange
//         ) {

//           selectShopifySize(
//             value
//           );

//         }

//       }, 100);

//     },
//     true
//   );


//   // =====================================================
//   // SHOPIFY SIZE CHANGE → ZEPTO
//   // Useful if customer somehow interacts with
//   // Shopify's hidden/original picker directly.
//   // =====================================================

//   document.addEventListener(
//     'change',
//     event => {

//       if (
//         programmaticChange
//       ) {
//         return;
//       }


//       const el =
//         event.target;


//       if (!el) return;


//       // Ignore Zepto properties
//       if (
//         String(
//           el.name || ''
//         ).startsWith(
//           'properties['
//         )
//       ) {
//         return;
//       }


//       const value =
//         normalize(
//           el.value
//         );


//       if (
//         !value.includes('x') &&
//         !value.includes('round')
//       ) {
//         return;
//       }


//       const shape =
//         getShapeFromSize(
//           el.value
//         );


//       if (!shape) return;


//       programmaticChange =
//         true;


//       setZeptoShape(
//         shape
//       );


//       setTimeout(() => {

//         setZeptoSize(
//           shape,
//           el.value
//         );


//         setTimeout(() => {

//           programmaticChange =
//             false;

//         }, 200);

//       }, 200);

//     },
//     true
//   );


//   // =====================================================
//   // WAIT UNTIL ZEPTO LOADS
//   // =====================================================

//   function waitForZepto(
//     attempt = 0
//   ) {

//     const zeptoReady =
//       document.querySelector(
//         '.pplr-drop-item, .pplr-swatch-element, [name^="properties["]'
//       );


//    if (zeptoReady) {

//   log(
//     'Zepto ready'
//   );

//   setTimeout(async () => {

//     const url =
//       new URL(
//         window.location.href
//       );

//     const hasVariantInURL =
//       !!url.searchParams.get('variant');


//     // ==========================================
//     // URL HAS VARIANT
//     // Respect exact Shopify variant
//     // ==========================================

//     if (hasVariantInURL) {

//       log(
//         'Variant found in URL → using Shopify variant'
//       );

//       selectZeptoFromShopifyVariant();

//       return;

//     }


//     // ==========================================
//     // NO VARIANT IN URL
//     // Force default Area 5' x 7'
//     // ==========================================

//     log(
//       `No variant in URL → default Area ${DEFAULT_SIZE.area}`
//     );


//     programmaticChange =
//       true;


//     setZeptoShape(
//       'area'
//     );


//     await sleep(250);


//     setZeptoSize(
//       'area',
//       DEFAULT_SIZE.area
//     );

//     // initializedShapes.add('area');
//     // await sleep(100);


//     programmaticChange =
//       false;


//     // IMPORTANT:
//     // Also click the real Shopify 5x7 option
//     // so price + variant + add to cart all match.
//     selectShopifySize(
//       DEFAULT_SIZE.area
//     );


//   }, 150);

//   return;
// }


//     if (
//       attempt >= 100
//     ) {

//       log(
//         'Zepto did not load'
//       );

//       return;

//     }


//     setTimeout(() => {

//       waitForZepto(
//         attempt + 1
//       );

//     }, 100);

//   }


//   // =====================================================
//   // START
//   // =====================================================

//   if (
//     document.readyState ===
//     'loading'
//   ) {

//     document.addEventListener(
//       'DOMContentLoaded',
//       () => {

//         waitForZepto();

//       }
//     );

//   } else {

//     waitForZepto();

//   }

// })();

(() => {
  // =====================================================
  // RUGMATTERS
  // SHOPIFY ↔ ZEPTO VARIANT SYNC
  // =====================================================

  const DEBUG = false;

  const log = (...args) => {
    if (DEBUG) {
      console.log('[RUG VARIANT SYNC]', ...args);
    }
  };


  // =====================================================
  // ZEPTO PROPERTY NAMES
  // =====================================================

  const SHAPE_PROPERTY = 'properties[Rug Shape]';

  const SIZE_PROPERTY = {
    area: 'properties[Area Rug Size]',
    runner: 'properties[Runner Rug Size]',
    square: 'properties[Square Rug Size]',
    round: 'properties[Round Rug Size]'
  };

  // Cache these instead of rebuilding them on every event.
  const SIZE_PROPERTIES = Object.values(SIZE_PROPERTY);

  const SHAPE_VALUES = new Set([
    'area',
    'runner',
    'square',
    'round'
  ]);


  // =====================================================
  // DEFAULT SIZE WHEN CUSTOMER CHANGES SHAPE
  // =====================================================

  const DEFAULT_SIZE = {
    area: `5' x 7'`,
    runner: `2.5' x 7'`,
    square: `5' x 5'`,
    round: `5' Round`
  };


  // =====================================================
  // PRODUCT ROOT
  // =====================================================

  let productRootCache = null;

  function getProductRoot() {
    if (
      productRootCache &&
      document.contains(productRootCache)
    ) {
      return productRootCache;
    }

    productRootCache =
      document.querySelector('main#content') ||
      document.querySelector('main') ||
      document;

    return productRootCache;
  }


  // =====================================================
  // HELPERS
  // =====================================================

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[’']/g, '')
      .replace(/["]/g, '')
      .replace(/[×*]/g, 'x')
      .replace(/\s*x\s*/g, 'x')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function escapeCSS(value) {
    if (
      window.CSS &&
      typeof CSS.escape === 'function'
    ) {
      return CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }


  function visible(element) {
    if (!element) return false;

    const style = getComputedStyle(element);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      !element.closest('[hidden]')
    );
  }


  function sleep(ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }


  // =====================================================
  // SYNC STATE
  // =====================================================

  let programmaticChange = false;

  const rememberedSizes = new Map();


  function rememberSize(shape, size) {
    shape = normalize(shape);

    if (!shape || !size) return;

    rememberedSizes.set(shape, size);

    log(
      'Remembered customer size:',
      shape,
      size
    );
  }


  function getSizeForShape(shape) {
    shape = normalize(shape);

    return (
      rememberedSizes.get(shape) ||
      DEFAULT_SIZE[shape] ||
      null
    );
  }


  // =====================================================
  // DETERMINE SHAPE FROM SIZE
  // =====================================================

  function getShapeFromSize(size) {
    const s = normalize(size);

    if (!s) return null;

    // ROUND
    if (s.includes('round')) {
      return 'round';
    }

    // RUNNER
    if (s.startsWith('2.5x')) {
      return 'runner';
    }

    // SQUARE
    const match = s.match(
      /^([\d.]+)x([\d.]+)$/
    );

    if (match) {
      const width = parseFloat(match[1]);
      const length = parseFloat(match[2]);

      if (
        !isNaN(width) &&
        !isNaN(length) &&
        width === length
      ) {
        return 'square';
      }
    }

    // Everything else = AREA
    return 'area';
  }


  // =====================================================
  // GET SHOPIFY PRODUCT JSON
  // =====================================================

  let shopifyProductCache = null;

  function getShopifyProduct() {
    if (shopifyProductCache) {
      return shopifyProductCache;
    }

    if (
      window.meta &&
      window.meta.product &&
      Array.isArray(window.meta.product.variants)
    ) {
      shopifyProductCache = window.meta.product;
      return shopifyProductCache;
    }

    const possibleJSON = [
      document.querySelector(
        'script[type="application/json"][data-product]'
      ),

      document.querySelector(
        'script[type="application/json"][data-product-json]'
      ),

      document.querySelector(
        'product-form script[type="application/json"]'
      ),

      document.querySelector(
        'script[id^="ProductJson-"]'
      )
    ].filter(Boolean);

    for (const element of possibleJSON) {
      try {
        const parsed = JSON.parse(
          element.textContent
        );

        if (
          parsed &&
          Array.isArray(parsed.variants)
        ) {
          shopifyProductCache = parsed;
          return parsed;
        }
      } catch (_) {}
    }

    log(
      'Could not find Shopify product JSON'
    );

    return null;
  }


  // =====================================================
  // CURRENT SHOPIFY VARIANT
  // =====================================================

  function getCurrentVariantId() {
    // Respect variant in URL first.
    const url = new URL(
      window.location.href
    );

    const urlVariant =
      url.searchParams.get('variant');

    if (urlVariant) {
      return Number(urlVariant);
    }

    const root = getProductRoot();

    const input =
      root.querySelector(
        'form[action*="/cart/add"] input[name="id"]'
      ) ||
      root.querySelector(
        'form[action*="/cart/add"] select[name="id"]'
      );

    if (
      input &&
      input.value
    ) {
      return Number(input.value);
    }

    return null;
  }


  // =====================================================
  // GET SIZE FROM SHOPIFY VARIANT
  // =====================================================

  function getVariantSize(variant) {
    if (!variant) return '';

    const options =
      variant.options ||
      variant.option_values ||
      [];

    const sizeOption =
      options.find(value => {
        const n = normalize(value);

        return (
          n.includes('x') ||
          n.includes('round')
        );
      });

    if (sizeOption) {
      return sizeOption;
    }

    const title =
      variant.public_title ||
      variant.title ||
      variant.name ||
      '';

    if (!title) return '';

    const parts = title.split(
      /\s[-–—]\s/
    );

    return (
      parts[parts.length - 1] || ''
    ).trim();
  }


  // =====================================================
  // FIND ZEPTO VISUAL BUTTON
  // =====================================================

  function findZeptoButton(text) {
    const target = normalize(text);

    const buttons = document.querySelectorAll(
      '.pplr-drop-item, .pplr-swatch-element'
    );

    let fallback = null;

    for (const button of buttons) {
      const value =
        button.getAttribute('data-value') ||
        button.textContent;

      if (
        normalize(value) !== target
      ) {
        continue;
      }

      if (visible(button)) {
        return button;
      }

      if (!fallback) {
        fallback = button;
      }
    }

    return fallback;
  }


  // =====================================================
  // SET ZEPTO SHAPE
  // =====================================================

  function setZeptoShape(shape) {
    shape = normalize(shape);

    if (!shape) return false;

    const expected =
      shape.charAt(0).toUpperCase() +
      shape.slice(1);

    log(
      'Selecting Zepto shape:',
      expected
    );

    const selector =
      `[name="${escapeCSS(
        SHAPE_PROPERTY
      )}"]`;

    const elements =
      document.querySelectorAll(selector);

    const targetNormalized =
      normalize(expected);

    for (const element of elements) {
      if (
        normalize(element.value) !==
        targetNormalized
      ) {
        continue;
      }

      if (
        element.tagName === 'SELECT'
      ) {
        if (
          normalize(element.value) !==
          targetNormalized
        ) {
          element.value = expected;

          element.dispatchEvent(
            new Event(
              'input',
              { bubbles: true }
            )
          );

          element.dispatchEvent(
            new Event(
              'change',
              { bubbles: true }
            )
          );
        }

        return true;
      }

      if (!element.checked) {
        element.click();
      }

      return true;
    }

    // Visual button fallback.
    const button =
      findZeptoButton(expected);

    if (button) {
      button.click();
      return true;
    }

    log(
      'Could not find Zepto shape:',
      expected
    );

    return false;
  }


  // =====================================================
  // SET ZEPTO SIZE
  // =====================================================

  function setZeptoSize(
    shape,
    size
  ) {
    shape = normalize(shape);

    if (
      !shape ||
      !size
    ) {
      return false;
    }

    const property =
      SIZE_PROPERTY[shape];

    if (!property) {
      log(
        'No Zepto size property for:',
        shape
      );

      return false;
    }

    log(
      'Selecting Zepto size:',
      shape,
      size
    );

    const target =
      normalize(size);

    const escapedProperty =
      escapeCSS(property);


    // ==========================================
    // RADIO
    // ==========================================

    const radios =
      document.querySelectorAll(
        `input[type="radio"][name="${escapedProperty}"]`
      );

    for (const radio of radios) {
      if (
        normalize(radio.value) ===
        target
      ) {
        if (!radio.checked) {
          radio.click();
        }

        return true;
      }
    }


    // ==========================================
    // SELECT
    // ==========================================

    const selects =
      document.querySelectorAll(
        `select[name="${escapedProperty}"]`
      );

    for (const select of selects) {
      for (
        const option of select.options
      ) {
        if (
          normalize(option.value) === target ||
          normalize(option.textContent) === target
        ) {
          select.value =
            option.value;

          select.dispatchEvent(
            new Event(
              'input',
              { bubbles: true }
            )
          );

          select.dispatchEvent(
            new Event(
              'change',
              { bubbles: true }
            )
          );

          return true;
        }
      }
    }


    // ==========================================
    // VISUAL FALLBACK
    // ==========================================

    const button =
      findZeptoButton(size);

    if (button) {
      button.click();
      return true;
    }

    log(
      'Could not find Zepto size:',
      size
    );

    return false;
  }


  // =====================================================
  // SHOPIFY → ZEPTO
  // =====================================================

  async function selectZeptoFromShopifyVariant() {
    const product =
      getShopifyProduct();

    if (!product) {
      log(
        'Shopify product JSON not ready'
      );

      return false;
    }

    const variantId =
      getCurrentVariantId();

    if (!variantId) {
      log(
        'No current Shopify variant ID'
      );

      return false;
    }

    const variant =
      product.variants.find(
        item =>
          Number(item.id) ===
          Number(variantId)
      );

    if (!variant) {
      log(
        'Shopify variant not found:',
        variantId
      );

      return false;
    }

    const size =
      getVariantSize(variant);

    if (!size) {
      log(
        'Could not determine Shopify variant size'
      );

      return false;
    }

    const shape =
      getShapeFromSize(size);

    log(
      'SHOPIFY → ZEPTO',
      'Variant:',
      variantId,
      'Shape:',
      shape,
      'Size:',
      size
    );

    programmaticChange = true;

    setZeptoShape(shape);

    // Give Zepto time to reveal
    // the correct size controls.
    await sleep(250);

    setZeptoSize(
      shape,
      size
    );

    await sleep(250);

    programmaticChange = false;

    return true;
  }


  // =====================================================
  // FIND SHOPIFY SIZE RADIO
  // =====================================================

  function findShopifySizeRadio(size) {
    const target =
      normalize(size);

    const root =
      getProductRoot();

    const radios =
      root.querySelectorAll(
        'input[type="radio"]'
      );

    for (const input of radios) {
      // Ignore Zepto properties.
      if (
        String(
          input.name || ''
        ).startsWith(
          'properties['
        )
      ) {
        continue;
      }

      if (
        normalize(input.value) ===
        target
      ) {
        return input;
      }

      if (input.id) {
        const label =
          root.querySelector(
            `label[for="${escapeCSS(
              input.id
            )}"]`
          ) ||
          document.querySelector(
            `label[for="${escapeCSS(
              input.id
            )}"]`
          );

        if (
          label &&
          normalize(
            label.textContent
          ) === target
        ) {
          return input;
        }
      }
    }

    return null;
  }


  // =====================================================
  // FIND SHOPIFY SIZE SELECT
  // =====================================================

  function findShopifySizeSelect(size) {
    const target =
      normalize(size);

    const root =
      getProductRoot();

    const selects =
      root.querySelectorAll('select');

    for (const select of selects) {
      if (
        String(
          select.name || ''
        ).startsWith(
          'properties['
        )
      ) {
        continue;
      }

      for (
        const option of select.options
      ) {
        if (
          normalize(option.value) === target ||
          normalize(option.textContent) === target
        ) {
          return {
            select,
            option
          };
        }
      }
    }

    return null;
  }


  // =====================================================
  // ZEPTO → SHOPIFY
  // =====================================================

  function selectShopifySize(size) {
    if (!size) return false;

    log(
      'ZEPTO → SHOPIFY SIZE:',
      size
    );


    // ==========================================
    // RADIO / BUTTON
    // ==========================================

    const radio =
      findShopifySizeRadio(size);

    if (radio) {
      log(
        'Found Shopify size radio:',
        radio.value
      );

      programmaticChange = true;

      /*
        Keep the same event sequence your
        current theme relies on.

        We can optimize this later after
        confirming everything works.
      */

      radio.checked = true;

      radio.dispatchEvent(
        new Event(
          'input',
          { bubbles: true }
        )
      );

      radio.dispatchEvent(
        new Event(
          'change',
          { bubbles: true }
        )
      );


      // Some themes bind to the label/button.
      if (radio.id) {
        const root =
          getProductRoot();

        const label =
          root.querySelector(
            `label[for="${escapeCSS(
              radio.id
            )}"]`
          ) ||
          document.querySelector(
            `label[for="${escapeCSS(
              radio.id
            )}"]`
          );

        if (label) {
          label.click();
        } else {
          radio.click();
        }
      } else {
        radio.click();
      }


      /*
        Keep your second change event
        for theme compatibility.
      */
      setTimeout(() => {
        radio.dispatchEvent(
          new Event(
            'change',
            { bubbles: true }
          )
        );
      }, 50);


      setTimeout(() => {
        programmaticChange = false;
      }, 400);


      return true;
    }


    // ==========================================
    // SELECT FALLBACK
    // ==========================================

    const foundSelect =
      findShopifySizeSelect(size);

    if (foundSelect) {
      log(
        'Found Shopify size select:',
        foundSelect.option.value
      );

      programmaticChange = true;

      foundSelect.select.value =
        foundSelect.option.value;

      foundSelect.select.dispatchEvent(
        new Event(
          'input',
          { bubbles: true }
        )
      );

      foundSelect.select.dispatchEvent(
        new Event(
          'change',
          { bubbles: true }
        )
      );

      setTimeout(() => {
        programmaticChange = false;
      }, 400);

      return true;
    }


    log(
      'SHOPIFY SIZE NOT FOUND:',
      size
    );

    return false;
  }


  // =====================================================
  // SHAPE CHANGE
  // RESTORE REMEMBERED SIZE OR DEFAULT
  // =====================================================

  async function selectSizeForShape(shape) {
    shape =
      normalize(shape);

    if (!shape) return;

    const target =
      getSizeForShape(shape);

    if (!target) return;

    log(
      rememberedSizes.has(shape)
        ? 'RESTORING CUSTOMER SIZE:'
        : 'USING SHAPE DEFAULT:',
      shape,
      target
    );

    programmaticChange = true;

    /*
      Allow Zepto to show the new
      shape's size controls.
    */
    await sleep(200);

    setZeptoSize(
      shape,
      target
    );

    await sleep(100);

    programmaticChange = false;

    /*
      Match Shopify variant,
      price, media and ATC.
    */
    selectShopifySize(target);
  }


  // =====================================================
  // MANUAL ZEPTO SHAPE CLICK
  // =====================================================

  document.addEventListener(
    'click',
    event => {
      if (
        programmaticChange
      ) {
        return;
      }

      const target =
        event.target;

      if (
        !target ||
        typeof target.closest !==
          'function'
      ) {
        return;
      }

      const button =
        target.closest(
          '.pplr-drop-item, .pplr-swatch-element'
        );

      if (!button) return;

      const value =
        normalize(
          button.getAttribute(
            'data-value'
          ) ||
          button.textContent
        );

      if (
        !SHAPE_VALUES.has(value)
      ) {
        return;
      }

      // Let Zepto handle its click first.
      setTimeout(() => {
        if (
          !programmaticChange
        ) {
          selectSizeForShape(value);
        }
      }, 50);
    },
    true
  );


  // =====================================================
  // ZEPTO SHAPE INPUT CHANGE
  // =====================================================

  document.addEventListener(
    'change',
    event => {
      if (
        programmaticChange
      ) {
        return;
      }

      const el =
        event.target;

      if (
        !el ||
        el.name !==
          SHAPE_PROPERTY
      ) {
        return;
      }

      const shape =
        normalize(el.value);

      if (
        !SHAPE_VALUES.has(shape)
      ) {
        return;
      }

      selectSizeForShape(shape);
    },
    true
  );


  // =====================================================
  // ZEPTO SIZE INPUT CHANGE
  // =====================================================

  document.addEventListener(
    'change',
    event => {
      if (
        programmaticChange
      ) {
        return;
      }

      const el =
        event.target;

      if (
        !el ||
        !el.name
      ) {
        return;
      }

      if (
        !SIZE_PROPERTIES.includes(
          el.name
        )
      ) {
        return;
      }

      const size =
        el.value;

      if (!size) return;

      const shape =
        getShapeFromSize(size);

      if (shape) {
        rememberSize(
          shape,
          size
        );
      }

      log(
        'Zepto size input changed:',
        size
      );

      setTimeout(() => {
        if (
          !programmaticChange
        ) {
          selectShopifySize(size);
        }
      }, 50);
    },
    true
  );


  // =====================================================
  // ZEPTO VISUAL SIZE CLICK FALLBACK
  // =====================================================

  document.addEventListener(
    'click',
    event => {
      if (
        programmaticChange
      ) {
        return;
      }

      const target =
        event.target;

      if (
        !target ||
        typeof target.closest !==
          'function'
      ) {
        return;
      }

      const button =
        target.closest(
          '.pplr-drop-item, .pplr-swatch-element'
        );

      if (!button) return;

      const rawValue =
        button.getAttribute(
          'data-value'
        ) ||
        button.textContent ||
        '';

      const value =
        rawValue.trim();

      const normalized =
        normalize(value);

      // Shape buttons are handled above.
      if (
        SHAPE_VALUES.has(normalized)
      ) {
        return;
      }

      // Must resemble a rug size.
      if (
        !normalized.includes('x') &&
        !normalized.includes('round')
      ) {
        return;
      }

      const shape =
        getShapeFromSize(value);

      if (shape) {
        rememberSize(
          shape,
          value
        );
      }

      log(
        'Zepto visual size clicked:',
        value
      );

      // Let Zepto finish first.
      setTimeout(() => {
        if (
          !programmaticChange
        ) {
          selectShopifySize(value);
        }
      }, 100);
    },
    true
  );


  // =====================================================
  // SHOPIFY SIZE CHANGE → ZEPTO
  // =====================================================

  document.addEventListener(
    'change',
    event => {
      if (
        programmaticChange
      ) {
        return;
      }

      const el =
        event.target;

      if (!el) return;

      // Ignore Zepto product properties.
      if (
        String(
          el.name || ''
        ).startsWith(
          'properties['
        )
      ) {
        return;
      }

      const value =
        normalize(el.value);

      if (
        !value.includes('x') &&
        !value.includes('round')
      ) {
        return;
      }

      const shape =
        getShapeFromSize(
          el.value
        );

      if (!shape) return;

      programmaticChange = true;

      setZeptoShape(shape);

      setTimeout(() => {
        setZeptoSize(
          shape,
          el.value
        );

        setTimeout(() => {
          programmaticChange = false;
        }, 200);

      }, 200);
    },
    true
  );


  // =====================================================
  // WAIT UNTIL ZEPTO LOADS
  // =====================================================

  function waitForZepto(
    attempt = 0
  ) {
    const zeptoReady =
      document.querySelector(
        '.pplr-drop-item, .pplr-swatch-element, [name^="properties["]'
      );

    if (zeptoReady) {
      log('Zepto ready');

      setTimeout(
        async () => {
          const url =
            new URL(
              window.location.href
            );

          const hasVariantInURL =
            !!url.searchParams.get(
              'variant'
            );


          // ==========================================
          // URL HAS VARIANT
          // ==========================================

          if (hasVariantInURL) {
            log(
              'Variant found in URL → using Shopify variant'
            );

            selectZeptoFromShopifyVariant();

            return;
          }


          // ==========================================
          // NO VARIANT
          // DEFAULT AREA 5' x 7'
          // ==========================================

          log(
            `No variant in URL → default Area ${DEFAULT_SIZE.area}`
          );

          programmaticChange = true;

          setZeptoShape('area');

          await sleep(250);

          setZeptoSize(
            'area',
            DEFAULT_SIZE.area
          );

          programmaticChange = false;

          /*
            Match Shopify variant + price +
            product image + Add to Cart.
          */
          selectShopifySize(
            DEFAULT_SIZE.area
          );
        },
        150
      );

      return;
    }


    // Stop after ~10 seconds.
    if (
      attempt >= 100
    ) {
      log(
        'Zepto did not load'
      );

      return;
    }


    setTimeout(() => {
      waitForZepto(
        attempt + 1
      );
    }, 100);
  }


  // =====================================================
  // START
  // =====================================================

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      waitForZepto,
      { once: true }
    );
  } else {
    waitForZepto();
  }

})();